module.exports = __webpack_public_path__ + "static/media/designPatent_1.cfbebb66.png";